import { render } from "./instrumentos.vue?vue&type=template&id=0b6faaf9"
import script from "./instrumentos.vue?vue&type=script&lang=js"
export * from "./instrumentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__